"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.If = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("../store");
function If({ children, field, is = Boolean, not, }) {
    const { [field]: value } = (0, store_1.useInputValues)(field);
    const child = (0, react_1.useCallback)((v) => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(v) }), [children]);
    if (not) {
        return child(value !== not);
    }
    if (typeof is === 'function') {
        return child(is(value));
    }
    return child(value === is);
}
exports.If = If;
